export default "__VITE_ASSET__BiKMR3tf__"